import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation, EffectFade } from 'swiper/modules';
import blogComingSoon from '../assets/images/blog-coming-soon.png';
import '../assets/style/blogSection.scss';

const Blog = () => (
  <>
    <h1 className="blog-h1">Blog</h1>
    <Swiper
      modules={[Pagination, Navigation, EffectFade]}
      direction="vertical"
      effect="fade"
      fadeEffect={{ crossFade: true }}
      allowTouchMove={false}
      className="blog-slider"
      spaceBetween={30}
      loop
      pagination={{ clickable: true, el: '.blog-pagination' }}
      navigation={{ prevEl: '.blog-nav__prev', nextEl: '.blog-nav__next' }}
    >
      <SwiperSlide className="blog-slider__item">
        <div className="blog-slider__img">
          <img
            src="https://miro.medium.com/v2/resize:fit:828/format:webp/1*78gbul6h0-pZ6GeGYCjUfA.png"
            alt="Remote vs home work"
          />
        </div>
        <div className="blog-slider__content">
          <span className="blog-slider__code">18 May 2022</span>
          <div className="blog-slider__title">
            Should I quit my traditional 9-5 job in Software Development?
            How Remote Work is going to change your life.
          </div>
          <div className="blog-slider__text">
            {'Roughly 47 million people quit their jobs in 2021 due to risk factors for more serious illness'.substring(0, 100)}
            ...
          </div>
          <div>
            <a
              className="blog-slider__button btn btn-1"
              target="_blank"
              rel="noreferrer"
              href="https://medium.com/@SaidRasinlic/should-i-quit-my-traditional-9-5-job-in-software-development-3bfc416db7c5"
            >
              <svg><rect x="0" y="0" fill="none" width="100%" height="100%" /></svg>
              READ MORE
            </a>
          </div>
        </div>
      </SwiperSlide>

      <SwiperSlide className="blog-slider__item blog-slider__item--soon">
        <div className="blog-slider__img">
          <img
            src={blogComingSoon}
            alt=""
          />
        </div>
        <div className="blog-slider__content">
          <span className="blog-slider__code">To be added...</span>
          <div className="blog-slider__title">New blog coming soon...</div>
          <div className="blog-slider__text">An awesome blog will be published soon!</div>
          <span style={{ display: 'block', cursor: 'not-allowed' }}>
            <a
              className="blog-slider__button btn btn-1"
              href="/#"
              style={{ pointerEvents: 'none', opacity: '0.5' }}
            >
              <svg><rect x="0" y="0" fill="none" width="100%" height="100%" /></svg>
              READ MORE
            </a>
          </span>
        </div>
      </SwiperSlide>

      <nav className="blog-nav" aria-label="Blog navigation">
        <button type="button" className="blog-nav__btn blog-nav__prev" aria-label="Previous slide">
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M18 15l-6-6-6 6"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <div className="blog-pagination" />
        <button type="button" className="blog-nav__btn blog-nav__next" aria-label="Next slide">
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M6 9l6 6 6-6"
              stroke="currentColor"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </nav>
    </Swiper>
  </>
);

export default Blog;
